import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import React from 'react';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

const list = Object.freeze([
  {
    id: '1',
    value: 'Indirizzo errato',
  },
  {
    id: '2',
    value: 'Titolo di soggiorno assente o inidoneo',
  },
  {
    id: '3',
    value: 'Compilazione errata o insufficiente del punto 6 sezione immobili',
  },
]);

interface ListReasonNotAvailableProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
}

const ListReasonNotAvailableComponent = ({
  disabled,
  required,
  onChange,
  value,
  error,
}: ListReasonNotAvailableProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} id="list-reason-label">
        {required ? 'Motivo *' : 'Motivo'}
      </InputLabel>
      <PmiSelect
        labelId="list-reason-label"
        id="list-reason"
        name="list-reason"
        value={value}
        label={required ? 'Motivo *' : 'Motivo'}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {(list as Array<ItemVM>)?.map((category: ItemVM) => (
          <MenuItem key={category.id} value={category.id}>
            {category.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListReasonNotAvailableComponent.displayName = 'List not available reason component';

const ListReasonNotAvailable = memo(ListReasonNotAvailableComponent);

export default ListReasonNotAvailable as typeof ListReasonNotAvailableComponent;
